import Negotiator from 'negotiator';
import { DEFAULT_LANGUAGE_ROUTE, SupportedLanguages } from '@shared/i18n/config/language';
import { LSK } from '@shared/utils/storage/config';

// 自定义支持的语言列表顺序（从优先级最高到最低）
const SUPPORTED_LANGUAGES = Object.values(SupportedLanguages);

// 获取浏览器语言并匹配支持的语言
function getUserLanguage(): SupportedLanguages {
	// 浏览器语言作为 Accept-Language
	const acceptLanguageHeader = navigator.languages.join(', ');
	const negotiator = new Negotiator({
		headers: { 'accept-language': acceptLanguageHeader },
	});

	const matchedLanguage = negotiator.language(
		negotiator.languages(), // 用户的首选语言列表
		SUPPORTED_LANGUAGES, // 自定义支持的语言列表
	);
	return (matchedLanguage as SupportedLanguages) || DEFAULT_LANGUAGE_ROUTE;
}

// 获取系统默认语言
export function getDefaultLanguage(): SupportedLanguages {
	const storedLanguage = localStorage.getItem(LSK.USER_LANGUAGE) as SupportedLanguages | null;
	//感觉不需要存这个切换过语言的时候路由已经处理过了, 后面整体看一下

	if (storedLanguage) {
		return storedLanguage; // 如果本地存储有语言设置，直接返回
	}

	// 使用 Negotiator 获取匹配语言
	const detectedLanguage = getUserLanguage();
	return detectedLanguage;
}
